var exports = {
  "iE": "xaee3c4fa--da05db--wrapper",
  "$0": "xaee3c4fa--da05db--title-wrapper",
  "HE": "xaee3c4fa--da05db--button-wrapper",
};

module.exports = exports;
